import { AppointmentBaseDto } from './appointment.base.dto.js';
export class AppointmentResponseDto extends AppointmentBaseDto {
}
//# sourceMappingURL=appointment.response.dto.js.map